export default function DirectoryEmptyState() {
  return (
    <div className="soft-card col-span-full p-8 text-center">
      <h2 className="text-2xl font-black text-neutral-950">No verified results match these filters.</h2>
      <p className="mt-3 text-neutral-600">Try removing one or more filters.</p>
    </div>
  );
}
